/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Learnmore1Inputs */

const zh_share_learnmore1 = /** @type {(inputs: Share_Learnmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解更多`)
};

const en_share_learnmore1 = /** @type {(inputs: Share_Learnmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn more`)
};

const es_share_learnmore1 = /** @type {(inputs: Share_Learnmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más información`)
};

/**
* | output |
* | --- |
* | "Learn more" |
*
* @param {Share_Learnmore1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const share_learnmore1 = /** @type {((inputs?: Share_Learnmore1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Learnmore1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_share_learnmore1(inputs)
	if (locale === "en") return en_share_learnmore1(inputs)
	return es_share_learnmore1(inputs)
});
export { share_learnmore1 as "share_learnMore" }